import { api } from './index';

import type { UserEmployment } from '@/types';

export interface GetSubscriptionDetailsParams {
  subscriptionId: string;
}

export interface GetUserEmploymentParams {
  userId: string;
}

export const miscApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Get subscription details
    getSubscriptionDetails: builder.query<
      unknown,
      GetSubscriptionDetailsParams
    >({
      providesTags: (_, __, { subscriptionId }) => [
        { id: subscriptionId, type: 'Subscription' },
        'Subscription',
      ],
      query: ({ subscriptionId }) => ({
        method: 'GET',
        url: `/user_payments/detailed_subscription/${subscriptionId}`,
      }),
    }),

    // Get user employment history
    getUserEmployment: builder.query<UserEmployment[], GetUserEmploymentParams>(
      {
        providesTags: (_, __, { userId }) => [
          { id: userId, type: 'UserEmployment' },
          'UserEmployment',
        ],
        query: ({ userId }) => ({
          method: 'GET',
          params: { user_id: userId },
          url: '/user_employments',
        }),
      },
    ),
  }),
});

export const { useGetSubscriptionDetailsQuery, useGetUserEmploymentQuery } =
  miscApi;
